// This is a config file for dev environment.

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  custom: false,
  version: '0.8.1',
  baseApiUrl: 'https://rdsap-api-dev.quidossoftware.co.uk/rdsap994',
  accept: 'application/json+RdSAP-quidos-ui, application/json',
  previewBaseUrl: 'http://dev-preview-epb.argylesoftware.co.uk/energy-certificate/',
  reportBaseUrl: 'https://getting-new-energy-certificate-integration.digital.communities.gov.uk/energy-certificate/',
  authUrl: 'https://auth.quidossoftware.co.uk/dev/v2/basic/token/refresh',
  xApiKey: 'S7UFlIUpmO1KSYLkSZMt4a3MnckKAhmz15jLgZK3',
  keycloakUrl: 'https://oauth-dev.quidossoftware.co.uk',
  clientId: 'rdsap994-editor'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
